module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-range-caa9f0ac.svg";